<template>
    <div class="discussion-list-users">
        <div class="discussion-list-users-items">
            <DiscussionInteractive />
        </div>
    </div>
</template>

<script>
    import DiscussionInteractive from "@/components/Panel/Interactive/DiscussionInteractive.vue";

export default {
    name: "DiscussionListUsersModal",
    components: {
        DiscussionInteractive
    },
    props: {
       
    },
    data() {
        return {
           
        }
    },
    computed: {
        
    },
    methods: {
        
    }
}
</script>

<style lang="scss" scoped>
    @import '@/assets/scss/discussion-list-users-modal.scss';
</style>

